import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';

class GoiChatBot extends Component {


    componentDidUpdate(prevProps) {
        // Check if the location changed
        if (this.props.location.pathname !== prevProps.location.pathname) {
            // Trigger your logic here (e.g., fetch new data)
        }
    }

    render() {
        const goi = "https://agents.contextsuite.com/embedded/v1/main.js?identifier=sendibilar&host=https://www.sendibilartilleigu.is" + this.props.location.pathname+ this.props.location.search
        return (
            <Helmet>
                <script async src={goi}>
                </script>
            </Helmet>
        );
    }
};

export default withRouter(GoiChatBot);
